import { render, staticRenderFns } from "./HazmatList.vue?vue&type=template&id=d79c40bc&scoped=true&"
import script from "./HazmatList.vue?vue&type=script&lang=js&"
export * from "./HazmatList.vue?vue&type=script&lang=js&"
import style0 from "./HazmatList.vue?vue&type=style&index=0&id=d79c40bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79c40bc",
  null
  
)

export default component.exports